/// <amd-module name="SuiteCommerce.Blog.DataProvider.Term.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.DataProvider.Term.Collection", ["require", "exports", "Backbone", "SuiteCommerce.Blog.DataProvider.Term.Model"], function (require, exports, Backbone_1, DataProvider_Term_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TermCollection = void 0;
    var TermCollection = /** @class */ (function (_super) {
        __extends(TermCollection, _super);
        function TermCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.model = DataProvider_Term_Model_1.TermModel;
            return _this;
        }
        TermCollection.prototype.getTermById = function (id) {
            return this.find(function (term) {
                return term.id === id;
            });
        };
        TermCollection.prototype.getTermByName = function (name) {
            return this.find(function (term) {
                return term.name === name;
            });
        };
        TermCollection.prototype.getTermByURLComponent = function (URLComponent) {
            return this.find(function (term) {
                return term.urlComponent === URLComponent;
            });
        };
        TermCollection.prototype.getTermByDefaultAlias = function (alias) {
            return this.find(function (term) {
                return term.defaultAlias === alias;
            });
        };
        return TermCollection;
    }(Backbone_1.Collection));
    exports.TermCollection = TermCollection;
});
